import { createContext } from "react";

import type { ConnectionState } from "./ConnectionState";

// Вне RealtimeProvider соединения нет — экраны работают на опросе API.
export const RealtimeContext = createContext<ConnectionState>("disconnected");
